import { render } from "./LivescoringRPR.vue?vue&type=template&id=424fa25a&scoped=true"
import script from "./LivescoringRPR.vue?vue&type=script&lang=js"
export * from "./LivescoringRPR.vue?vue&type=script&lang=js"

import "./LivescoringRPR.vue?vue&type=style&index=0&id=424fa25a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424fa25a"]])

export default __exports__